import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as TablerIcons from "@tabler/icons-react";
import classNames from "classnames";
import "./Icon.scss";
import { styleClasses } from "../../helpers";
import { CustomIcons } from "./CustomIcons";
const CSS_PREFIX = `lav-components-icon`;
const ICON_SIZES = {
    mini: {
        height: 14,
        width: 14,
    },
    "extra-small": {
        height: 16,
        width: 16,
    },
    small: {
        height: 20,
        width: 20,
    },
    medium: {
        height: 24,
        width: 24,
    },
    large: {
        height: 32,
        width: 32,
    },
};
export const Icon = (_a) => {
    var { className = "", color = "dark", size = "small", variant } = _a, iconProps = __rest(_a, ["className", "color", "size", "variant"]);
    const IconComponent = Object.assign(Object.assign({}, TablerIcons), CustomIcons)[variant];
    return (_jsx(IconComponent, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { color, size }), {
            [className]: !!className,
        }) }, ICON_SIZES[size], iconProps)));
};
